import type { LogoType } from "@otto-ec/icons";

export const logoLabels = {
  "app-store": "Laden im App Store",
  ehi: "EHI Geprüfter Online-Shop",
  facebook: "Facebook",
  github: "Github",
  instagram: "Instagram",
  linkedin: "LinkedIn",
  mastercard: "Mastercard Logo",
  otto: "OTTO Logo",
  "otto-app": "OTTO App",
  "otto-deprecated": "OTTO Logo",
  "otto-payments": "OTTO Payments Logo",
  "otto-up": "OTTO-Up Logo",
  paypal: "PayPal Logo",
  "paypal-monogram": "PayPal Logo",
  pinterest: "Pinterest",
  "play-store": "Jetzt bei Google Play",
  "sepa-horizontal": "SEPA Lastschrift Logo",
  "sepa-vertical": "SEPA Lastschrift Logo",
  slogan: "Otto... find ich gut.",
  snapchat: "Snapchat",
  tiktok: "Tiktok",
  up: "OTTO-Up Logo",
  visa: "Visa Logo",
  xing: "Xing",
  youtube: "Youtube",
} satisfies Record<LogoType, string>;
